import { AxiosUpdateTuple, usePutAxiosHook } from '../../AxiosPutHook';

const URL = '/api/clients/update-flagged';

export const useUpdateClientFlagged = (): AxiosUpdateTuple => {
  const [callBack, { data, loading, called, error }] = usePutAxiosHook(URL);

  return [callBack, { data, loading, called, error }];
};
